<div *ngIf="!loader"
     class="col-12 col-md-12 col-lg-12 col-xl-12 pl-0 vh-100">

    <div id="main2"
         class="vh-100 no-padding col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">

        <ng-scrollbar #scrollable track="all"
                      pointerEventsMethod="scrollbar">
            <div class="row ml-4">
                <div class="d-inline p-2">
                    <h1 class="bold d-inline-block">
                        Projekti</h1>
                </div>
            </div>


            <div class="col-lg-12 col-xl-12 mt-4">

                <div class="projects-card mr-3 mb-3"
                     (click)="activateProject(project._id)"
                     *ngFor="let project of projects;"
                     [ngClass]="{'projects-activeProject': userActivatedProjectId===project._id}">
                    <div class="cursor">
                        <span [title]="project.name"
                              class="badge projects-name-badge full-width">
                            {{project.name}}
                        </span>
                    </div>

                    <div class="media">
                        <img class="align-self-start mr-3 projects-logo"
                             src="https://testfinanceplus.proventum.me/content/avatar/avatar_51.png"
                             alt="Generic placeholder image">

                        <div class="media-body cursor">
                            <h4 class="mt-1 mb-1">
                                <a [routerLink]="['/boards', project._id]">
                                    Boards</a>
                            </h4>
                            <h4 class="mt-1 mb-0">
                                <a routerLinkActive="active"
                                   [routerLink]="['/backlog', project._id]">
                                    Backlog</a>
                            </h4>
                        </div>

                    </div>
                </div>

            </div>
        </ng-scrollbar>
    </div>
</div>
